import React, {useState} from 'react'
import { Button, Table } from 'react-bootstrap'
import ResourceContext from "../contexts/ResourceContext"
import ResourceListPagination from "../components/ResourceListPagination"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons"
import ResourceList from "./ResourceList"
import Time from "../lib/Time"
import InstrumentAlarmNoteModal from './InstrumentAlarmNoteModal'
import { InstrumentAlarmNote } from '../Resources'
import ResourceEditButton from './ResourceEditButton'
import ResourceDeleteButton from './ResourceDeleteButton'

const InstrumentAlarmEventIndex = ({alarm}) => {
  const [ openEvents, setOpenEvents ] = useState([])
  const [selectedNote, setSelectedNote] = useState(null)

  const handleEditNote = (event, resource) => {
    if (resource.instrumentAlarmNote() === null) {
      setSelectedNote(InstrumentAlarmNote.build({ instrumentAlarmEvent: resource }))
    } else {
      setSelectedNote(resource.instrumentAlarmNote())
    }
    event.preventDefault()
    event.stopPropagation()
    return false
  }

  const toggleEvent = (resource) => {
    if (openEvents.includes(resource.id))
      setOpenEvents(openEvents.filter(id => id !== resource.id))
    else
      setOpenEvents(openEvents.concat([resource.id]))
  }

  const baseQuery = () => {
    return alarm.instrumentAlarmEvents().includes('notifications.user','instrumentAlarmNote')
  }

  const details = (resource) => {
    let details = ''
    switch(resource.cause){
      case 'value_off_range':
        details = resource.dataValuesWithRanges && resource.dataValuesWithRanges.map(v => (
          `${v.key}: ${v.value} (valid range: ${v.range})`
        )).join(', ')
        break
      case 'issues_cleared':
        details = resource.dataValues && Object.entries(resource.dataValues).map(entry => `${entry[0]}: ${entry[1]}`).join(', ')
        break
      case 'sensor_muted':
        details = <span>Last data <Time.Duration>{resource.dataAgeSecs * 1000}</Time.Duration> ago (limit: {resource.alarmProperties && resource.alarmProperties.dataAgeThresholdMins} minutes)</span>
        break
      default:
        details = ''
    }
    if (resource.commandNames) {
      details = `${details} - Commands sent: ${resource.commandNames.join(', ')}`
    }
    return details
  }

  return (
    <ResourceContext baseQuery={baseQuery()} defaultSort={{createdAt: 'desc'}}>
      <Table striped bordered hover>
        <thead>
        <tr>
          <th>Logged at</th>
          <th>Cause</th>
          <th>Details</th>
          <th className="actions"></th>
        </tr>
        </thead>
        <tbody>
        <ResourceList>
          {resource => <React.Fragment key={resource.id}>
            <tr className="clickable" onClick={() => resource.hasDetails() && toggleEvent(resource)}>
              <td><Time>{resource.createdAt}</Time></td>
              <td>{resource.causeToHuman()}</td>
              <td>{details(resource)}</td>
              <td className="actions">
                {resource.instrumentAlarmNote() === null && resource.requiresNote && (
                  <Button onClick={(ev) => handleEditNote(ev, resource)} variant='link'>
                    Add note
                  </Button>
                )}
                {resource.hasDetails() &&
                <Button variant="link">
                  {!openEvents.includes(resource.id) &&
                  <FontAwesomeIcon icon={faChevronRight} />}
                  {openEvents.includes(resource.id) &&
                  <FontAwesomeIcon icon={faChevronDown} />}
                </Button>}
              </td>
            </tr>
            <tr style={{display: openEvents.includes(resource.id) ? 'table-row' : 'none'}}>
              <td colSpan={5}>
                {resource.instrumentAlarmNote() !== null && (
                  <>
                    <h6>Note</h6>
                    <p>{resource.instrumentAlarmNote().note.split('\n').map(row => <div>{row}</div>)}</p>
                    <p>
                      {resource.instrumentAlarmNote().updaterInfo && (
                        <i>{resource.instrumentAlarmNote().updaterInfo} - {Time.formatTime(resource.instrumentAlarmNote().updatedAt)}</i>
                      )}
                      {!resource.instrumentAlarmNote().updaterInfo && (
                        <i>{resource.instrumentAlarmNote().creatorInfo} - {Time.formatTime(resource.instrumentAlarmNote().createdAt)}</i>
                      )}
                    </p>
                    <ResourceEditButton resource={resource.instrumentAlarmNote()} onClick={(ev) => handleEditNote(ev, resource)} />
                    <ResourceDeleteButton resource={resource.instrumentAlarmNote()} popoverPlacement='right' onDelete={() => toggleEvent(resource)} />
                  </>
                )}
                {!resource.notifications().empty() && (
                  <>
                    <h6>Notifications</h6>
                    {resource.notifications().toArray().map(notification => <dl className="row" key={notification.id + 'notification'}>
                      <dt className="col-auto">User:</dt>
                      <dd>{notification.user().name}</dd>
                      <dt className="col-auto">Sent at:</dt>
                      <dd>{notification.sentAt ? <Time>{notification.sentAt}</Time> : <span>-</span>}</dd>
                      <dt className="col-auto">Contact info:</dt>
                      <dd>{notification.contactInfo ? JSON.stringify(notification.contactInfo) : <span>-</span>}</dd>
                    </dl>)}
                  </>
                )}
              </td>
            </tr>
          </React.Fragment>}
        </ResourceList>
        </tbody>
      </Table>
      <ResourceListPagination/>
      <InstrumentAlarmNoteModal
        resource={selectedNote}
        onClose={() => setSelectedNote(null)}
        show={selectedNote !== null}
      />
    </ResourceContext>
  )
}

export default InstrumentAlarmEventIndex
